import React from 'react';
import { getDesignLossesSourceLabel } from './designLossesFinanceGate';
import './oneButton-css/DesignLossesSourceBadge.css';

export type DesignLossesSourceBadgeProps = {
    lossesSource?: string | null;
    className?: string;
};

export const DesignLossesSourceBadge: React.FC<DesignLossesSourceBadgeProps> = ({
    lossesSource,
    className = '',
}) => {
    const label = getDesignLossesSourceLabel(lossesSource);
    if (!label) return null;

    return (
        <span
            className={`obd-design-losses-badge${className ? ` ${className}` : ''}`}
            title={`Design losses source: ${label}`}
        >
            {label}
        </span>
    );
};

export default DesignLossesSourceBadge;
